import { CMSpotify } from "./spotify-icon.styles";
import { ReactComponent as SpotifyIcon } from '../../icons/spotify.svg';

const Spotify = ({spotifyLink}) => {
    return (
        <CMSpotify>
            <a href={spotifyLink} target="_blank" rel="noopener noreferrer">
                <SpotifyIcon/>
                Play on Spotify
            </a>
        </CMSpotify>
    );
}

export default Spotify;